import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import Cielogo from '../../icons/Cielogo';
import { useTranslation } from 'react-i18next';
import { links } from '../../links';
import { Link } from 'react-router';
import { theme } from '@pagopa/mui-italia';

const Header = () => {
  const { t } = useTranslation();
  const smUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <Box component={'header'}>
        <Stack
          component={'nav'}
          py={2}
          px={3}
          bgcolor={'customBlue.main'}
          direction={'row'}
          justifyContent={'space-between'}
        >
          <Typography
            to={links.header}
            target="_blank"
            rel="noopener noreferrer"
            component={Link}
            color={'primary.contrastText'}
            fontWeight={'600'}
            variant="body2"
            sx={{ textDecoration: 'none' }}
          >
            {t('commons.ministryOfInterior')}
          </Typography>
          {smUp && ( // show public area link only on large screens
            <Typography
              to={links.public}
              target="_blank"
              rel="noopener noreferrer"
              component={Link}
              color={'primary.contrastText'}
              fontWeight={'600'}
              variant="body2"
              sx={{ textDecoration: 'none' }}
            >
              {t('header.publicArea')}
            </Typography>
          )}
        </Stack>
        <Stack
          aria-hidden
          direction="row"
          py={2}
          px={3}
          bgcolor={'primary.main'}
          alignItems={'center'}
        >
          <Cielogo
            height={smUp ? '64' : '32'}
            width={smUp ? '129' : '64.29'}
            title={'Logo ' + t('commons.cieTitle')}
          />
        </Stack>
      </Box>
    </>
  );
};

export default Header;
